const ADVANCED_PACKAGES = new Set(['Individual Advanced', 'Enterprise Advanced']);

export function isAdvancedPackage(packageName) {
  return ADVANCED_PACKAGES.has(packageName);
}
